import PlanUsageCardShell from './PlanUsageCardShell'
import { PlanUsagePlanTierCardBody } from './PlanUsagePlanTierCardBody'

/**
 * @param {{
 *   sectionAriaLabel: string, shellTitle: string, titleIcon?: import('react').ReactNode,
 *   planName: string, priceLine: string, description: string, actionLabel: string, onAction?: () => void,
 * }} props
 */
export default function PlanUsagePlanTierCard({ sectionAriaLabel, shellTitle, titleIcon, planName, priceLine, description, actionLabel, onAction }) {
  return (
    <PlanUsageCardShell sectionAriaLabel={sectionAriaLabel} title={shellTitle} titleIcon={titleIcon}>
      <PlanUsagePlanTierCardBody planName={planName} priceLine={priceLine} description={description} actionLabel={actionLabel} onAction={onAction} />
    </PlanUsageCardShell>
  )
}
